export default __webpack_public_path__ + "static/media/XEMP-21.72a41d0f.jpg";